import React from 'react';
import { Card, Button, Typography, theme } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import RoomForm  from  "./roomForm";
import { useNavigate, useParams } from 'react-router-dom';
import { RoomData } from '@/AppRedux/actions/admin/roomDetailConfig/roomDetailConfigType';
const { Title, Text } = Typography;


const CreateRoom: React.FC = () => {
  const { token } = theme.useToken();
  const { propcode } = useParams<{ propcode: string }>();
  const navigate = useNavigate();

  const handleSubmit = async (values: RoomData) => {
    console.log('Creating room with data:', values);
    
  };

  const onBack = () => {
    // Navigate back to room list
    navigate(-1);
  }


  return (
     <div style={{ maxWidth: 1000, margin: '0 auto' }}>
      <Card>
        {/* Header */}
        <div style={{ marginBottom: 32 }}>
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={onBack}
            style={{ marginBottom: 16 }}
          >
            Back to Room List
          </Button>
          <Title level={2} style={{ margin: 0 }}>
            Create New Room
          </Title>
          <Text type="secondary">Add a new room type to your hotel inventory</Text>
        </div>

        {/* Form */}
        <RoomForm mode="create" onSubmit={handleSubmit} propCode={propcode || ''} />
      </Card>
    </div>
  );
};

export default CreateRoom;